module.exports = __webpack_public_path__ + "img/menu-bottom-icon-double-circles-outline.cb0be40d.svg";